import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { propertyResponseType, nameExistType, updateResponse, updatePayload, saveResponse, discountValueType, roleArr, customerGroupType, customerType, productArr, categoryArr, productItem } from "../../components/discounts/buyXgetYDiscount/addEditBuyXgetYDiscountModule";
import { posBuyXgetYDiscount, payloadType, discountTypes, bulkDeleteType, deleteData } from "../../components/discounts/buyXgetYDiscount/buyXgetYDiscountModule";
import { rolesResponseProps, setRoleProps } from "../../components/role/roleModule";
import { CustomerGroupDataProps, GetAllPosCustomerGroupResProps } from "../../components/customerGroups/customerGroupModule";

interface commonType {
    loading: boolean,
    error: string
}

interface discountProp {
    storeId: number;
    data: payloadType | undefined;
}

interface IntialValueProps {
    loading: boolean,
    discountTypeResponse: commonType & { value: discountTypes | null },
    bulkDeleteResponse: commonType & { value: bulkDeleteType | null },
    updateDiscount: commonType & { value: deleteData | null },
    discountVal: null | posBuyXgetYDiscount,
    checkExistName: commonType & { value: nameExistType | null },
    error: string,
    propertyCode: commonType & { value: propertyResponseType | null },
    updatePosDiscount: commonType & { value: updateResponse | null }
    savePosDiscount: commonType & { value: saveResponse | null }
    getOneDiscount: commonType & { value: discountValueType | null },
    getDiscountAppliesTo: commonType & { value: rolesResponseProps | GetAllPosCustomerGroupResProps | customerType | productArr | categoryArr | null },
    productData: commonType & { value: productItem[] | null },
    categoryData: commonType & { value: categoryArr | null },
    roleData: commonType & { value: setRoleProps[] | null },
    customerGroupData: commonType & { value: CustomerGroupDataProps[] | null },
    customerData: commonType & { value: customerType | null },
}

const initialState: IntialValueProps = {
    loading: true,
    discountTypeResponse: { value: null, loading: true, error: "" },
    bulkDeleteResponse: { value: null, loading: true, error: "" },
    updateDiscount: { value: null, loading: true, error: "" },
    discountVal: null,
    checkExistName: { value: null, loading: true, error: "" },
    error: '',
    propertyCode: { value: null, loading: true, error: "" },
    updatePosDiscount: { value: null, loading: true, error: "" },
    savePosDiscount: { value: null, loading: true, error: "" },
    getOneDiscount: { value: null, loading: true, error: "" },
    getDiscountAppliesTo: { value: null, loading: true, error: "" },
    productData: { value: null, loading: true, error: "" },
    categoryData: { value: null, loading: true, error: "" },
    roleData: { value: null, loading: true, error: "" },
    customerGroupData: { value: null, loading: true, error: "" },
    customerData: { value: null, loading: true, error: "" },
}

export const getBuyXgetYDiscounts = createAsyncThunk("buyXgetYDiscount/getBuyXgetYDiscounts", ({ storeId, data }: discountProp) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosDiscount, { storeId: storeId })
    return HttpRoutingService?.getMethod<posBuyXgetYDiscount>(url, data)
})

export const getDiscountTypes = createAsyncThunk("buyXgetYDiscount/getDiscountTypes", (storeId: number) => {
    const url = HttpRoutingService?.replaceUrl(API?.getDiscountTypes, { storeId })
    return HttpRoutingService?.getMethod<discountTypes>(url)
})

export const buyXgetYBulkDeleteDiscount = createAsyncThunk("buyXgetYDiscount/buyXgetYBulkDeleteDiscount", ({ storeId, data }: { storeId: number, data: number[] }) => {
    const url = HttpRoutingService.replaceUrl(API.bulkDeleteDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<bulkDeleteType>(url, { id: data })
})

export const buyXgetYUpdateDiscountStatus = createAsyncThunk("buyXgetYDiscount/buyXgetYUpdateDiscountStatus", ({ storeId, discountId, data, action }: { storeId: number, discountId: number, data: { isActive?: boolean, isDeleted?: true }, action: string }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: discountId })
    const response = action === 'delete' ?
        HttpRoutingService?.deleteMethod<deleteData>(url, data) :
        HttpRoutingService?.putMethod<deleteData>(url, data); return response;
})

export const checkExistBuyXgetYDiscountName = createAsyncThunk("addEditBuyXgetYDiscount/checkExistBuyXgetYDiscountName", ({ storeId, data }: { storeId: number, data: { title: string } }) => {
    const url = HttpRoutingService?.replaceUrl(API?.checkExistBuyXgetYDiscountName, { storeId: storeId })
    return HttpRoutingService?.getMethod<nameExistType>(url, data, 'v1/')
})

export const getPosPropertyCode = createAsyncThunk("addEditBuyXgetYDiscount/getPosPropertyCode", ({ storeId, propertyValue }: { storeId: number, propertyValue: string[] }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPosPropertyCode, { storeId: storeId })
    return HttpRoutingService?.getMethod<propertyResponseType>(url, { code: JSON.stringify(propertyValue) })
})

export const updateBuyXgetY = createAsyncThunk("addEditBuyXgetYDiscount/updateBuyXgetY", ({ storeId, discountId, data }: { storeId: number, discountId: number, data: updatePayload }) => {
    const url = HttpRoutingService.replaceUrl(API?.updateBuyXgetY, { storeId: storeId, discountId: discountId })
    return HttpRoutingService?.putMethod<updateResponse>(url, data)
})

export const saveBuyXgetY = createAsyncThunk("addEditBuyXgetYDiscount/saveBuyXgetY", ({ storeId, data }: { storeId: number, data: updatePayload }) => {
    const url = HttpRoutingService.replaceUrl(API?.saveBuyXgetY, { storeId: storeId })
    return HttpRoutingService?.postMethod<saveResponse>(url, data)
})

export const getOneDiscount = createAsyncThunk("buyXgetYDiscount/getOnePosDiscount", ({ storeId, discountId }: { storeId: number, discountId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOnePosDiscount, { storeId: storeId, discountId: discountId })
    return HttpRoutingService?.getMethod<discountValueType>(url)
})

export const getDiscountAppliesTo = createAsyncThunk("buyXgetYDiscount/getDiscountAppliesTo", ({ storeId, url, data }: { storeId: number, url: string, data: any }) => {
    return HttpRoutingService.getMethod<rolesResponseProps | GetAllPosCustomerGroupResProps | customerType | productArr | categoryArr>('stores/' + storeId + url, data,);
})

export const BuyXgetYDiscountSlice = createSlice({
    name: "buyXgetYDiscount",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getBuyXgetYDiscounts?.pending, (state) => {
                state.loading = true
            })
            .addCase(getBuyXgetYDiscounts?.fulfilled, (state, action: PayloadAction<posBuyXgetYDiscount>) => {
                state.loading = false
                state.discountVal = action?.payload
            })
            .addCase(getBuyXgetYDiscounts?.rejected, (state, action) => {
                state.loading = false
                state.error = action?.error?.message as string
            })
            .addCase(getDiscountTypes?.pending, (state) => {
                state.discountTypeResponse.loading = true
            })
            .addCase(getDiscountTypes?.fulfilled, (state, action) => {
                state.discountTypeResponse.loading = false
                state.discountTypeResponse.value = action?.payload
            })
            .addCase(getDiscountTypes?.rejected, (state, action) => {
                state.discountTypeResponse.loading = false
                state.discountTypeResponse.error = action?.error?.message as string
            })
            .addCase(getOneDiscount?.pending, (state) => {
                state.getOneDiscount.loading = true
            })
            .addCase(getOneDiscount?.fulfilled, (state, action) => {
                state.getOneDiscount.loading = false
                state.getOneDiscount.value = action?.payload
            })
            .addCase(getOneDiscount?.rejected, (state, action) => {
                state.discountTypeResponse.loading = false
                state.discountTypeResponse.error = action?.error?.message as string
            })
            .addCase(buyXgetYBulkDeleteDiscount?.pending, (state) => {
                state.bulkDeleteResponse.loading = true
            })
            .addCase(buyXgetYBulkDeleteDiscount?.fulfilled, (state, action) => {
                state.bulkDeleteResponse.loading = false
                state.bulkDeleteResponse.value = action?.payload
            })
            .addCase(buyXgetYBulkDeleteDiscount?.rejected, (state, action) => {
                state.bulkDeleteResponse.loading = false
                state.bulkDeleteResponse.error = action?.error?.message as string
            })
            .addCase(buyXgetYUpdateDiscountStatus?.pending, (state) => {
                state.updateDiscount.loading = true
            })
            .addCase(buyXgetYUpdateDiscountStatus?.fulfilled, (state, action) => {
                state.updateDiscount.loading = false
                state.updateDiscount.value = action?.payload
            })
            .addCase(buyXgetYUpdateDiscountStatus?.rejected, (state, action) => {
                state.updateDiscount.loading = false
                state.updateDiscount.error = action?.error?.message as string
            })
            .addCase(checkExistBuyXgetYDiscountName?.pending, (state) => {
                state.checkExistName.loading = true
            })
            .addCase(checkExistBuyXgetYDiscountName?.fulfilled, (state, action) => {
                state.checkExistName.loading = false
                state.checkExistName.value = action?.payload
            })
            .addCase(checkExistBuyXgetYDiscountName?.rejected, (state, action) => {
                state.checkExistName.loading = false
                state.checkExistName.error = action?.error?.message as string
            })
            .addCase(getPosPropertyCode?.pending, (state) => {
                state.propertyCode.loading = true
            })
            .addCase(getPosPropertyCode?.fulfilled, (state, action) => {
                state.propertyCode.loading = false
                state.propertyCode.value = action?.payload
            })
            .addCase(getPosPropertyCode?.rejected, (state, action) => {
                state.propertyCode.loading = false
                state.propertyCode.error = action?.error?.message as string
            })
            .addCase(updateBuyXgetY?.pending, (state) => {
                state.updatePosDiscount.loading = true
            })
            .addCase(updateBuyXgetY?.fulfilled, (state, action) => {
                state.updatePosDiscount.loading = false
                state.updatePosDiscount.value = action?.payload
            })
            .addCase(updateBuyXgetY?.rejected, (state, action) => {
                state.updatePosDiscount.loading = false
                state.updatePosDiscount.error = action?.error?.message as string
            })
            .addCase(saveBuyXgetY?.pending, (state) => {
                state.savePosDiscount.loading = true
            })
            .addCase(saveBuyXgetY?.fulfilled, (state, action) => {
                state.savePosDiscount.loading = false
                state.savePosDiscount.value = action?.payload
            })
            .addCase(saveBuyXgetY?.rejected, (state, action) => {
                state.savePosDiscount.loading = false
                state.savePosDiscount.error = action?.error?.message as string
            })
            .addCase(getDiscountAppliesTo?.pending, (state) => {
                state.getDiscountAppliesTo.loading = true
            })
            .addCase(getDiscountAppliesTo?.rejected, (state, action) => {
                state.getDiscountAppliesTo.loading = false
                state.getDiscountAppliesTo.error = action?.error?.message as string
            })
            .addCase(getDiscountAppliesTo?.fulfilled, (state, action) => {
                state.getDiscountAppliesTo.loading = false
                state.getDiscountAppliesTo.value = action?.payload
                if (action.meta.arg.url.includes('/products/name')) {
                    state.productData.value = (action.payload as productArr)?.products?.rows || null
                    state.productData.loading = false
                }
                else if (action.meta.arg.url.includes('/categories/name')) {
                    state.categoryData.value = action.payload as categoryArr
                    state.categoryData.loading = false
                }
                else if (action.meta.arg.url.includes('/roles')) {
                    state.roleData.value = (action.payload as rolesResponseProps)?.roles?.rows
                    state.roleData.loading = false
                }
                else if (action.meta.arg.url.includes('/customers/group')) {
                    state.customerGroupData.value = (action.payload as GetAllPosCustomerGroupResProps)?.customergroup?.rows
                    state.customerGroupData.loading = false
                }
                else if (action.meta.arg.url.includes('/customers/name') || action.meta.arg.url.endsWith('/customers')) {
                    state.customerData.value = action.payload as customerType
                    state.customerData.loading = false
                }
            })
    }
})

export default BuyXgetYDiscountSlice?.reducer